import { API_URL, CLIENT_ID, CLIENT_SECRET, RECAPTCHA_SITEKEY } from '@/modules/shared/constants';

// Re-export config values used by auth module
export { API_URL, CLIENT_ID, CLIENT_SECRET, RECAPTCHA_SITEKEY };

// OTP
export const OTP_LENGTH = 4;
export const OTP_EXPIRY_MS = 10 * 60 * 1000; // 10 minutes
export const OTP_AUTO_RESEND_AFTER_FAILURES = 3;
export const OTP_MAX_ATTEMPTS = 20;

// PIN
export const PIN_MAX_ATTEMPTS = 3;
export const PIN_MIN_LENGTH = 8;

// Auth intents
export const AUTH_INTENTS = {
  LOGIN: 'login',
  RESET_PIN: 'reset_pin',
} as const;

// API error codes returned by backend
export const AUTH_ERROR_CODES = {
  ACCOUNT_DOES_NOT_EXIST: 'account_does_not_exist',
  ACCOUNT_EXISTS: 'account_exists',
  INVALID_OTP: 'invalid_otp',
  INVALID_GRANT: 'invalid_grant',
  INVALID_PIN: 'invalid_pin',
  BANNED_USER: 'banned_user',
  INACTIVE_USER: 'inactive_user',
} as const;

// Locale keys for error messages — used with t() from useAuthTranslation
export const AUTH_ERROR_KEYS = {
  ACCOUNT_NOT_FOUND: 'errorAccountNotFound',
  ACCOUNT_EXISTS: 'errorAccountExists',
  INVALID_MOBILE: 'errorInvalidMobile',
  ACCOUNT_BLOCKED: 'errorAccountBlocked',
  MULTIPLE_ACCOUNTS: 'errorMultipleAccounts',
  GENERIC_ERROR: 'errorGeneric',
  INVALID_OTP: 'errorInvalidOtp',
  OTP_BLOCKED: 'errorOtpBlocked',
  OTP_RESEND_BLOCKED: 'errorOtpResendBlocked',
  OTP_RESEND_FAILED: 'errorOtpResendFailed',
  OTP_SEND_FAILED: 'errorOtpSendFailed',
  WRONG_PIN: 'errorWrongPin',
  ACCOUNT_LOCKED: 'errorAccountLocked',
  EMAIL_NOT_VERIFIED: 'errorEmailNotVerified',
  LOGIN_FAILED: 'errorLoginFailed',
  PIN_SET_FAILED: 'errorPinSetFailed',
  MISSING_OTP: 'errorMissingOtp',
  EXPIRED_RESET_LINK: 'errorExpiredResetLink',
  PASSWORD_RESET_FAILED: 'errorPasswordResetFailed',
  PROFILE_LOAD_FAILED: 'errorProfileLoadFailed',
} as const;

// Query param names for account type flags
export const ACCOUNT_TYPE_PARAMS = {
  INSPECTION_GARAGE: 'ig',
  DIRECT_AGENT: 'direct_agent',
  BUSINESS_MANAGER: 'business_manager',
} as const;

// API Endpoints — self-contained, no dependency on legacy apiEndpoints.js
export const AUTH_ENDPOINTS = {
  login: `${API_URL}profile/login`,
  logout: `${API_URL}auth/revoke-token`,
  userProfile: `${API_URL}profile/user`,
  tokenLogin: `${API_URL}profile/token-login`,
  requestOtp: `${API_URL}profile/request-otp`,
  openUserDetails: `${API_URL}profile/open-user`,
  otpPinReset: `${API_URL}profile/resetpin-via-otp`,
  resetPassword: `${API_URL}profile/user/reset-password`,
  setPasswordEmail: `${API_URL}crm/affiliate-set-password-email/`,
  affiliateProfile: `${API_URL}crm/affiliate-profile`,
  affiliates: `${API_URL}crm/affiliates`,
  systemSettings: `${API_URL}system-settings`,
} as const;
